// client/src/helpers/socket.ts
//
// One socket.io connection per tab to the api's `/events` namespace.
// Authentication joins the account room, so every tab receives state hints.
// Authoritative snapshots repair missed events after reconnect.
import { io, Socket } from "socket.io-client";
import { getToken } from "./request";

let socket: Socket | null = null;

const socketUrl = (): string => {
  const base =
    (import.meta.env.VITE_SOCKET_URL as string | undefined) ||
    (import.meta.env.VITE_API_URL as string | undefined) ||
    "";
  return `${base.replace(/\/$/, "")}/events`;
};

export function getSocket(): Socket | null {
  // DEV mock mode (src/dev/mockApi) has no socket server; consumers already handle null.
  if (import.meta.env.DEV) {
    if (window.__STREAMINAL_MOCK__) return null;
  }
  if (!getToken()) return null;
  if (!socket) {
    socket = io(socketUrl(), {
      // A function so every (re)connect sends the token that is current
      // now — login-as-user swaps the token without a reload.
      auth: (cb) => cb({ token: getToken() ?? "" }),
      transports: ["websocket", "polling"],
      autoConnect: true,
    });
  }
  if (!socket.connected && !socket.active) socket.connect();
  return socket;
}

export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
